import OptimizationModal from './OptimizationModal';

export default OptimizationModal;
